import type { AuditLogEntry } from '@core/api/auditLog';
import { AuditAction } from '@core/enum/auditAction';
import {
  type AuditLogRenderer,
  formatAuditSubjectDescription,
} from '@core/utils/auditLog';

function renderEntityCrud(
  entry: AuditLogEntry,
  verb: 'created' | 'updated' | 'deleted'
) {
  const { typeLabel, idPart } = formatAuditSubjectDescription(entry);
  return (
    <>
      {typeLabel}
      {idPart} {verb}
    </>
  );
}

export const renderEntityCreated: AuditLogRenderer = (entry) =>
  renderEntityCrud(entry, 'created');

export const renderEntityUpdated: AuditLogRenderer = (entry) =>
  renderEntityCrud(entry, 'updated');

export const renderEntityDeleted: AuditLogRenderer = (entry) =>
  renderEntityCrud(entry, 'deleted');

export const ENTITY_CRUD_RENDERERS: Partial<
  Record<AuditAction, AuditLogRenderer>
> = {
  [AuditAction.EntityCreated]: renderEntityCreated,
  [AuditAction.EntityUpdated]: renderEntityUpdated,
  [AuditAction.EntityDeleted]: renderEntityDeleted,
};
